export const deleteUnnecessaryEmptyLines = (text: string) => {
  const trimmedText = text.trim();
  const modifiedText = `${trimmedText}\n\n`;
  return modifiedText.replace(/\n{3,}/g, '\n\n');
};
